import { exchangeOffersAPI } from '@/api/admin/exchangeOffers';

const state = () => ({
  escrowList: [],
  platformList: [],
  sellerAndOperatorList: [],
})

const mutations = {
  setEscrowList (state, data) {
    state.escrowList = data
  },
  setPlatformList (state, data) {
    state.platformList = data
  },
  setSellerAndOperatorList (state, data) {
    state.sellerAndOperatorList = data
  },
}

const actions = {
  async getTransfersList ({commit}, status) {
    try {
      commit('setEscrowList', []);
      commit('setPlatformList', []);
      commit('setSellerAndOperatorList', []);
      const result = await exchangeOffersAPI.getTransfers(status);
      if (result.data.isSuccessfull) {
        if (status === 0) {
          commit('setEscrowList', result.data.item);
        } else if (status === 1) {
          commit('setPlatformList', result.data.item);
        } else if (status === 2) {
          commit('setSellerAndOperatorList', result.data.item);
        }
        console.log(result.data.item)
      }
    } catch (e) {
      console.log('e', e)
    }
  },
  clearTransfersList ({commit}) {
    commit('setList', []);
  },
  async transferMoneFromEscrowToPlatform ({commit}, transferId) {
    try {
      const result = await exchangeOffersAPI.transferMoneFromEscrowToPlatform(transferId);
      return result.data;
    } catch (e) {
      console.log('e', e)
    }
  },
  async transferMoneToSellerAndOperator ({commit}, transferId) {
    try {
      const result = await exchangeOffersAPI.transferMoneToSellerAndOperator(transferId);
      return result.data;
    } catch (e) {
      console.log('e', e)
    }
  },
}

export default {
  state,
  mutations,
  actions,
}